// Bug-list "kind" filter → SQL. The `kind` query param is a comma-separated list of kinds (e.g.
// `accessibility,seo,testing`) so the Bugs tab can show any combination of kinds; a single kind and
// `all` keep working as before. `testing` isn't a polish category — it's a bug filed by a test run with
// no polish_category — so it becomes its own OR'd clause beside the category match.
export function parseBugKinds(kind: string | undefined): string[] {
  if (!kind) return []
  const kinds = [...new Set(kind.split(',').map(k => k.trim()).filter(Boolean))]
  return kinds.includes('all') ? [] : kinds
}

// Returns the WHERE clause (or null when no kind filter applies) and the params it consumes, numbered
// from `paramIndex`.
export function bugKindCondition(kind: string | undefined, paramIndex: number): { sql: string; params: unknown[] } | null {
  const kinds = parseBugKinds(kind)
  if (kinds.length === 0) return null
  const categories = kinds.filter(k => k !== 'testing')
  const clauses: string[] = []
  const params: unknown[] = []
  if (categories.length > 0) {
    clauses.push(`b.polish_category = ANY($${paramIndex}::text[])`)
    params.push(categories)
  }
  if (kinds.includes('testing')) clauses.push(`(b.polish_category IS NULL AND b.test_run_id IS NOT NULL)`)
  return { sql: clauses.length === 1 ? clauses[0]! : `(${clauses.join(' OR ')})`, params }
}
